export default "__VITE_ASSET__bb39d1fc__"